module.exports = __webpack_public_path__ + "img/longitude.33025a82.svg";